module.exports = __webpack_public_path__ + "static/img/03.23e395c3.png";